import { NavigateFunction } from 'react-router-dom';

import { Avatar, Button, Tag } from '../../../../designComponents';
import theme from '../../../../theme';
import { fake_avatar_url } from '../../../../utils';
import { ClientStyled } from './style';

export const getTableData = (navigate: NavigateFunction) => {
  return {
    headings: [
      { key: 'date', label: 'Date' },
      { key: 'clientName', label: 'Client Name' },
      { key: 'email', label: 'Email Address' },
      { key: 'shippingAddress', label: 'Shipping Address' },
      { key: 'actions', label: 'Action' },
      { key: 'status', label: 'Status' },
    ],
    body: [
      {
        id: '1',
        date: '12 aug 2023 - 12:59 am',
        clientName: (
          <ClientStyled>
            <Avatar size="sm" src={fake_avatar_url} />
            <span>Sachin Bhattarai</span>
          </ClientStyled>
        ),
        email: 'sachin.client@gmail.com',
        shippingAddress: 'Bhaktapur',
        actions: <Tag type="success">Generated</Tag>,
        status: (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant="secondary"
              onClick={() => navigate(`details/${1}`)}
              style={{
                backgroundColor: theme.colors.blueLight,
                border: `1px solid ${theme.colors.blueLight}`,
              }}
            >
              View Details
            </Button>
          </div>
        ),
      },
      {
        id: '2',
        date: '12 aug 2023 - 12:59 am',
        clientName: (
          <ClientStyled>
            <Avatar size="sm" src={fake_avatar_url} className="flag" />
            <span>Sachin Bhattarai</span>
          </ClientStyled>
        ),
        email: 'sachin.client@gmail.com',
        shippingAddress: 'Bhaktapur',
        actions: <Tag type="success">Generated</Tag>,
        status: (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant="secondary"
              onClick={() => navigate(`details/${1}`)}
              style={{
                backgroundColor: theme.colors.blueLight,
                border: `1px solid ${theme.colors.blueLight}`,
              }}
            >
              View Details
            </Button>
          </div>
        ),
      },
      {
        id: '3',
        date: '12 aug 2023 - 12:59 am',
        clientName: (
          <ClientStyled>
            <Avatar size="sm" src={fake_avatar_url} className="flag" />
            <span>Sachin Bhattarai</span>
          </ClientStyled>
        ),
        email: 'sachin.client@gmail.com',
        shippingAddress: 'Bhaktapur',
        actions: <Tag type="success">Generated</Tag>,
        status: (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant="secondary"
              onClick={() => navigate(`details/${1}`)}
              style={{
                backgroundColor: theme.colors.blueLight,
                border: `1px solid ${theme.colors.blueLight}`,
              }}
            >
              View Details
            </Button>
          </div>
        ),
      },
      {
        id: '4',
        date: '12 aug 2023 - 12:59 am',
        clientName: (
          <ClientStyled>
            <Avatar size="sm" src={fake_avatar_url} className="flag" />
            <span>Sachin Bhattarai</span>
          </ClientStyled>
        ),
        email: 'sachin.client@gmail.com',
        shippingAddress: 'Bhaktapur',
        actions: <Tag type="success">Generated</Tag>,
        status: (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant="secondary"
              onClick={() => navigate(`details/${1}`)}
              style={{
                backgroundColor: theme.colors.blueLight,
                border: `1px solid ${theme.colors.blueLight}`,
              }}
            >
              View Details
            </Button>
          </div>
        ),
      },
      {
        id: '5',
        date: '12 aug 2023 - 12:59 am',
        clientName: (
          <ClientStyled>
            <Avatar size="sm" src={fake_avatar_url} className="flag" />
            <span>Sachin Bhattarai</span>
          </ClientStyled>
        ),
        email: 'sachin.client@gmail.com',
        shippingAddress: 'Bhaktapur',
        actions: <Tag type="success">Generated</Tag>,
        status: (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant="secondary"
              onClick={() => navigate(`details/${1}`)}
              style={{
                backgroundColor: theme.colors.blueLight,
                border: `1px solid ${theme.colors.blueLight}`,
              }}
            >
              View Details
            </Button>
          </div>
        ),
      },
      {
        id: '6',
        date: '12 aug 2023 - 12:59 am',
        clientName: (
          <ClientStyled>
            <Avatar size="sm" src={fake_avatar_url} className="flag" />
            <span>Sachin Bhattarai</span>
          </ClientStyled>
        ),
        email: 'sachin.client@gmail.com',
        shippingAddress: 'Bhaktapur',
        actions: <Tag type="success">Generated</Tag>,
        status: (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant="secondary"
              onClick={() => navigate(`details/${1}`)}
              style={{
                backgroundColor: theme.colors.blueLight,
                border: `1px solid ${theme.colors.blueLight}`,
              }}
            >
              View Details
            </Button>
          </div>
        ),
      },
      {
        id: '7',
        date: '12 aug 2023 - 12:59 am',
        clientName: (
          <ClientStyled>
            <Avatar size="sm" src={fake_avatar_url} className="flag" />
            <span>Sachin Bhattarai</span>
          </ClientStyled>
        ),
        email: 'sachin.client@gmail.com',
        shippingAddress: 'Bhaktapur',
        actions: <Tag type="success">Generated</Tag>,
        status: (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant="secondary"
              onClick={() => navigate(`details/${1}`)}
              style={{
                backgroundColor: theme.colors.blueLight,
                border: `1px solid ${theme.colors.blueLight}`,
              }}
            >
              View Details
            </Button>
          </div>
        ),
      },
    ],
  };
};
